import type { CSSProperties } from 'react';
import { IS_FR } from '@/utils/constants';
import { env } from '@/utils/env';
import { PaymentIcon } from './PaymentIcon';

// 显式组合地区品牌；行数由外层容器的可用宽度决定。
export function FrancePaymentMethods() {
  return (
    <>
      <PaymentIcon icon="frPaypal" />
      <PaymentIcon icon="frCb" />
      <PaymentIcon icon="visa" />
      <PaymentIcon icon="frMastercard" />
      <PaymentIcon icon="frMaestro" />
      <PaymentIcon icon="frAmex" />
      <PaymentIcon icon="frDiscover" />
      <PaymentIcon icon="frDiners" />
      {env.NEXT_PUBLIC_SHOW_KLARNA === 'true' ? <PaymentIcon icon="frKlarna" /> : null}
    </>
  );
}

export function DefaultPaymentMethods() {
  return (
    <>
      <PaymentIcon icon="paypal" />
      <PaymentIcon icon="visa" />
      <PaymentIcon icon="mastercard" />
      <PaymentIcon icon="maestro" />
      <PaymentIcon icon="amex" />
      <PaymentIcon icon="discover" />
      <PaymentIcon icon="jcb" />
      <PaymentIcon icon="diners" />
      {env.NEXT_PUBLIC_SHOW_KLARNA === 'true' ? <PaymentIcon icon="klarna" /> : null}
      {env.NEXT_PUBLIC_SHOW_AFTER_PAY === 'true' ? <PaymentIcon icon="afterpay" /> : null}
    </>
  );
}

interface PaymentMethodsProps {
  size?: 'compact' | 'legacy';
}

type PaymentStyles = CSSProperties & {
  '--payment-gap': string;
  '--payment-icon-width': string;
  '--payment-icon-ratio': string;
};

export function FooterMobilePayments({ size = 'compact' }: PaymentMethodsProps) {
  const gap = size === 'legacy' ? 6 : 8;
  const iconWidth = size === 'legacy' ? 41 : 36;
  const style: PaymentStyles = {
    '--payment-gap': `${gap}px`,
    '--payment-icon-width': `${iconWidth}px`,
    '--payment-icon-ratio': size === 'legacy' ? '41 / 25' : '3 / 2',
  };

  return (
    <div
      className="flex w-full flex-wrap items-center justify-center gap-[var(--payment-gap)]"
      style={style}
    >
      {IS_FR ? <FrancePaymentMethods /> : <DefaultPaymentMethods />}
    </div>
  );
}

export function FooterDesktopPayments({ size = 'compact' }: PaymentMethodsProps) {
  const style: PaymentStyles = {
    '--payment-gap': '8px',
    '--payment-icon-width': size === 'legacy' ? '50px' : '36px',
    '--payment-icon-ratio': size === 'legacy' ? '5 / 3' : '3 / 2',
  };

  return (
    <div className="flex items-center gap-[var(--payment-gap)]" style={style}>
      {IS_FR ? <FrancePaymentMethods /> : <DefaultPaymentMethods />}
    </div>
  );
}
